module.exports = __webpack_public_path__ + "img/pin.529e7f9f.svg";